import React from 'react'

export default function Input({ tipo, mensajeFondo, ...rest }) {
  return (
    <div className='form-group'>
      <input
        {...rest}
        type={tipo}
        className='form-control form-control-user'
        placeholder={mensajeFondo}
      />
    </div>
  )
}
